var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16183",
    "data-name": "Rectangle 16183",
    width: 27.58,
    height: 19.126,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15648",
    "data-name": "Group 15648",
    transform: "translate(-164 -246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16180",
    "data-name": "Rectangle 16180",
    width: 71,
    height: 73,
    rx: 35.5,
    transform: "translate(164 246)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15468",
    "data-name": "Group 15468",
    transform: "translate(185.664 271.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15468-2",
    "data-name": "Group 15468",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41225",
    "data-name": "Path 41225",
    d: "M13.767,19.126H.809c-.758,0-.808-.051-.808-.817Q0,9.582,0,.855C0,.128.129,0,.872,0H26.678c.724,0,.9.168.9.911q.005,8.672,0,17.344c0,.759-.125.87-.908.871h-12.9m0-.906c4.08,0,8.16-.009,12.24.012.52,0,.657-.176.656-.662q-.016-7.983,0-15.965c0-.531-.191-.69-.707-.689q-12.185.017-24.37,0c-.512,0-.7.139-.695.68q.027,7.983,0,15.966c0,.541.173.671.689.669,4.062-.019,8.123-.01,12.185-.01",
    transform: "translate(0 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41226",
    "data-name": "Path 41226",
    d: "M4.4,24.506l3.692-5.028c.378-.516.75-1.036,1.138-1.545a1.038,1.038,0,0,1,1.852-.027c.57.713,1.091,1.465,1.638,2.2.074.1.169.183.3.321.155-.191.3-.352.423-.522q2.309-3.134,4.616-6.269c.629-.851,1.31-.862,1.942-.007q3.943,5.335,7.864,10.686a1.713,1.713,0,0,1,.1.195Z",
    transform: "translate(-2.435 -7.191)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41227",
    "data-name": "Path 41227",
    d: "M7.57,10.257A1.873,1.873,0,0,1,5.646,8.38a1.907,1.907,0,1,1,3.813-.042A1.876,1.876,0,0,1,7.57,10.257",
    transform: "translate(-3.126 -3.539)",
    fill: "#161615"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.ca35e9f3b43ab54f111c25b0841dc18b.svg";
export { ForwardRef as ReactComponent };